import styled from 'styled-components'

export const ParticipantContainer = styled.div`
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 50%;
`

export const VideoView = styled.video`
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: 50%;

    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);

    @media only screen and (max-width: 900px) {
        border-radius: 50%;
    }
    @media only screen and (min-width: 768px) and (max-width: 1366px) {
        border-radius: 50%;
    }
`
export const VideoContainer = styled.div`
    float: left;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    object-fit: cover;
    background: ${props => (props.showBgColor ? '#FBCC40' : 'none')};
`
